export const fixedRules = [
  {
    title: '“Waarom?” bij alles',
    body: 'Elke actie en elk voorstel heeft een Waarom?-link: aanleiding → doel → gebruikte data.',
  },
  {
    title: 'Lokaal of cloud',
    body: 'Elk resultaat laat zien waar het verwerkt is.',
  },
  {
    title: 'Sloten, alarm, betalingen',
    body: 'Nooit met een goedkeurknop of aftelling. Alleen informatie: "open zelf via …".',
  },
  {
    title: 'Geen verzonnen huisgenoten',
    body: 'Geen gezin, kinderen, partners of andere bewoners. Anna zegt "jij". Namen alleen voor klanten en contacten in voorbeelddata, zoals Lisa (nieuwe klant) en klant Bakker.',
  },
  {
    title: 'Noodstop altijd bereikbaar',
    body: '2 s vasthouden. Toont wat stopt en wat blijft werken.',
  },
];

export const noodstopStops = [
  'Alle agents: Code, Mail, Slack, Agenda, Boekhouding, Huis, Studio, Initiatief',
  'Lopende aftellingen (Niveau 2) worden geannuleerd',
  'Wachtende voorstellen blijven staan; er wordt niets verstuurd',
  'Cloud-verzoeken en proactieve meldingen',
  'Microfoons van de spraaksatellieten',
];

export const noodstopKeeps = [
  'Rook- en waterlekalarm',
  'Sloten en alarm, die bedien je zelf, zoals altijd',
  'Lichtschakelaars en thermostaat op de huidige stand',
  'Camera-opnames, lokaal',
  'Logboek: alles wat stopte wordt vastgelegd',
];
